import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

import { CertificatesTab } from '../CertificatesTab';
import { CertificateShowClick } from '../../../config/Validate';
import { formatDate } from '../../../appconfig/AppHelper';
import { DOWNLOAD_DEGREE_ADDITION_CERTIFICATE, GET_DEGREE_ADDITION_CERTIFICATE } from '../../../config/ApiConstant';
import { getAllDetails, getAllDetailsDirect } from '../../../service/ProductService';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { AdditionalCertListShowColumns } from '../../../appconfig/DatatableSetting';
import { loadavg } from 'os';
import Loader from '../../../components/Loadeer/Loader';

export const AdditionalCertificate = () => {
    document.title = 'Additional Certificate | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [certificateList, setCertificateList] = useState<any>([]);
    const [regNo, setRegNo] = useState<any>(null);
    const [certificateData, setCertificateData] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});

    // On show click
    const onShowClick = async () => {
        try {
            const { errors, isError } = CertificateShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                setPageLoad(false);

                const response = await getAllDetailsDirect(GET_DEGREE_ADDITION_CERTIFICATE + '?regNo=' + regNo);
                if (window.cn(response.Details)) {
                    setShowLoading(false);
                    setPageLoad(false);
                    toast.current?.show({ severity: 'error', summary: 'Message', detail: 'Registration Number Is Wrong!' });
                } else {
                    if (!window.cn(response.Details) && !window.cn(response.Details[0])) {
                        setShowLoading(false);
                        setPageLoad(true);
                        setCertificateData(response.Details[0]);
                        if (response?.List) {
                            setCertificateList(response.List);
                        }
                    }
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    // Template for issue date
    const IssueDateTemplate = (rowData: any) => {
        return <>{!window.cn(rowData.DCertIDt) ? formatDate(rowData.DCertIDt) : ''}</>;
    };

    // Template for PAddress
    const PAddressTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.PAddress} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.PAddress) ? rowData.PAddress : ''}</div>
                </Button>
            </>
        );
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" tooltip="Download" tooltipOptions={{ position: 'top' }} className="p-button-primary" onClick={() => downloadDegreeCert(rowData.SrNo, rowData.RNo)} loading={showLoading} />
                </div>
            </>
        );
    };

    // Download degree cert
    const downloadDegreeCert = async (SrNo: any, RNo: any) => {
        try {
            setLoading(true);
            const response = await getAllDetails(DOWNLOAD_DEGREE_ADDITION_CERTIFICATE + '/' + SrNo + '/' + RNo);
            if (!window.cn(response)) {
               
                window.open(response?.file_url, '_blank');
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                setLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setCertificateData({});
        setCertificateList([]);
        setErrors({});
    };

    return (
        <>
           <CertificatesTab  mainTabLabel="Additional Certificate" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    Reg No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" autoComplete="off" placeholder="Enter Reg No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Show" className="p-button-primary" onClick={() => onShowClick()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">Name</label>
                                <InputText value={!window.cn(certificateData?.Name) ? certificateData?.Name : ''} name="Name" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="DegNm">Degree</label>
                                <InputText value={!window.cn(certificateData?.DegNm) ? certificateData?.DegNm : ''} name="DegNm" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="EntDt">Reg Date</label>
                                <InputText value={!window.cn(!window.cn(certificateData?.EntDt) ? certificateData?.EntDt : '') ? formatDate(certificateData?.EntDt) : ''} name="EntDt" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="PAddress">To Address</label>
                                <InputTextarea rows={5} cols={30} value={!window.cn(certificateData?.PAddress) ? certificateData?.PAddress : ''} name="PAddress" disabled={true} />
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary" onClick={() => clearAll()} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Certificates Found"
                                >
                                    {AdditionalCertListShowColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'DCertIDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={IssueDateTemplate} />;
                                        } else if (col.field === 'PAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={PAddressTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AdditionalCertListShowColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {loading && <Loader />}
        </>
    );
};
